playlistClearItem